/* eslint-disable max-len */
import produce, { castDraft, } from 'immer';
import { AlertingActionType, } from './actions';
const alertRulesByProjectIdByAlertRuleIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case AlertingActionType.SET_ALERT_RULES:
            return produce(currentState, (draft) => {
                const { projectId, alertRules } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                alertRules.items.forEach((alertRule) => {
                    temp[alertRule.id] = castDraft(alertRule);
                });
            });
        case AlertingActionType.SET_ALERT_RULE:
            return produce(currentState, (draft) => {
                const { projectId, alertRule } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[alertRule.id] = castDraft(alertRule);
            });
        case AlertingActionType.CLEAR_ALERT_RULES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const alertRuleIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case AlertingActionType.SET_ALERT_RULES:
            return produce(currentState, (draft) => {
                const { projectId, alertRules, searchParams } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[searchParams] = {
                    range: alertRules.range,
                    items: alertRules.items.map((alertRule) => {
                        return alertRule.id;
                    }),
                };
            });
        case AlertingActionType.CLEAR_ALERT_RULES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const alertsByProjectIdByAlertIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case AlertingActionType.SET_ALERTS:
            return produce(currentState, (draft) => {
                const { projectId, alerts } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                alerts.items.forEach((alert) => {
                    temp[alert.id] = castDraft(alert);
                });
            });
        case AlertingActionType.SET_ALERT:
            return produce(currentState, (draft) => {
                const { projectId, alert } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[alert.id] = castDraft(alert);
            });
        case AlertingActionType.CLEAR_ALERTS:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const alertIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case AlertingActionType.SET_ALERTS:
            return produce(currentState, (draft) => {
                const { projectId, alerts, searchParams } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[searchParams] = {
                    range: alerts.range,
                    items: alerts.items.map((alert) => {
                        return alert.id;
                    }),
                };
            });
        case AlertingActionType.CLEAR_ALERTS:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
export const alertRulesStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.alertRulesByProjectIdByAlertRuleId = castDraft(alertRulesByProjectIdByAlertRuleIdReducer(currentState.alertRulesByProjectIdByAlertRuleId, action));
        draft.alertRuleIdsByProjectId = castDraft(alertRuleIdsByProjectIdReducer(currentState.alertRuleIdsByProjectId, action));
        draft.alertsByProjectIdByAlertId = castDraft(alertsByProjectIdByAlertIdReducer(currentState.alertsByProjectIdByAlertId, action));
        draft.alertIdsByProjectId = castDraft(alertIdsByProjectIdReducer(currentState.alertIdsByProjectId, action));
    });
};
